import { createContext, useContext } from "react";

export const ThemeContext = createContext({
  mode: "dark",
  toggleTheme: () => {},
});

const useTheme = () => {
  const toggleTheme = useContext(ThemeContext).toggleTheme;
  const mode = useContext(ThemeContext).mode;
  return { toggleTheme, mode };
};

export { useTheme };
